import { combineReducers } from "redux";
import getElsLookupsReducer from "./getElsLookupsReducer";
import getLookupsReducer from "./lookupsReducer";
import getAffordableHousingRatesReducer from "./getAffordableHousingRatesReducer";

const lookupsReducer = combineReducers({
    getElsLookups: getElsLookupsReducer,
    getLookups: getLookupsReducer,
    getAffordableHousingRates: getAffordableHousingRatesReducer
});

export default lookupsReducer;